import { useState, useEffect } from 'react';

import { useEventListener } from 'usehooks-ts';

interface Size {
  width: number;
  height: number;
}

function useElementSize<T extends HTMLElement = HTMLDivElement>(
  dependencies: boolean[] = []
): [(node: T | null) => void, Size] {
  'use memo';

  const [ref, setRef] = useState<T | null>(null);
  const [size, setSize] = useState<Size>({
    width: 0,
    height: 0
  });

  const handleSize = () => {
    setSize({
      width: ref?.scrollWidth || 0,
      height: ref?.scrollHeight || 0
    });
  };

  useEventListener('resize', handleSize);

  const serializedDependencies = JSON.stringify(dependencies);
  useEffect(handleSize, [
    ref?.scrollWidth,
    ref?.scrollHeight,
    serializedDependencies
  ]);

  return [setRef, size];
}

export default useElementSize;
